// Role page v2 content (wave 1). First GENERATED Sep 23 2026 by Maeve's gen_v2.py; since Oct 2026 edited in place
// (breadth pass Oct 23 2026: audience cards, 5th prompt, 3 FAQs). Keep FAQ = visible list (FAQPage JSON-LD).
/* eslint-disable */
const content = {
 "slug": "ai-executive-assistant",
 "roleDisplay": "AI Executive Assistant",
 "phrase": "ai executive assistant",
 "seo": {
  "title": "AI Executive Assistant: Inbox, Calendar, Meetings | CellCog",
  "description": "An AI executive assistant that triages your inbox, untangles your calendar, joins your Google Meet, Zoom and Microsoft Teams calls, and preps a briefing before each meeting."
 },
 "painSub": "The inbox fills faster than you can clear it, and every meeting needs prep you never get to. Your AI executive assistant clears the noise, fixes the calendar and has the brief ready before you walk in.",
 "definition": "An AI executive assistant is an AI employee that triages your inbox, drafts replies, resolves calendar conflicts, joins your video calls and prepares a briefing before each meeting. On CellCog they are hired in minutes, read the email and calendar you connect, and research the people you meet with the agent ranked #1 on DeepResearch Bench (October 2026).",
 "panes": [
  {
   "num": "01 · INBOX",
   "title": "Clears your inbox.",
   "sub": "They sort every message, draft the replies and flag the few that need you.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--inbox\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Inbox</span></div><div class=\"rf-body\"><div class=\"rf-head\"><b>Sam&#x27;s inbox</b><span>Triaged at 8:00 am</span></div><div class=\"rf-counts\"><span class=\"rf-count rf-tone-amber\"><b>3</b> need you</span><span class=\"rf-count rf-tone-blue\"><b>5</b> replies drafted</span><span class=\"rf-count rf-tone-graphite\"><b>38</b> archived</span></div><ul class=\"rf-mails rf-panel\"><li class=\"rf-mail\"><span class=\"rf-av rf-tone-amber\">HG</span><div class=\"rf-mail-m\"><div class=\"rf-mail-top\"><b>Harlow Group</b><span>9:12</span></div><span class=\"rf-mail-s\">Questions before Thursday</span><span class=\"rf-mail-p\">Two phase 2 scope questions, answers drafted.</span></div><span class=\"rf-chip rf-tone-amber\">Needs you</span></li><li class=\"rf-mail\"><span class=\"rf-av rf-tone-blue\">MR</span><div class=\"rf-mail-m\"><div class=\"rf-mail-top\"><b>Marco Ruiz</b><span>8:47</span></div><span class=\"rf-mail-s\">Site visit next week</span><span class=\"rf-mail-p\">Tuesday at 2:00 works. Reply drafted with parking notes.</span></div><span class=\"rf-chip rf-tone-blue\">Drafted</span></li><li class=\"rf-mail\"><span class=\"rf-av rf-tone-blue\">DC</span><div class=\"rf-mail-m\"><div class=\"rf-mail-top\"><b>Dana Cole</b><span>8:30</span></div><span class=\"rf-mail-s\">Friday client lunch</span><span class=\"rf-mail-p\">Asks to move to 1:00. Reply drafted, calendar ready.</span></div><span class=\"rf-chip rf-tone-blue\">Drafted</span></li><li class=\"rf-mail\"><span class=\"rf-av rf-tone-amber\">LD</span><div class=\"rf-mail-m\"><div class=\"rf-mail-top\"><b>Lisbon Design Week</b><span>Mon</span></div><span class=\"rf-mail-s\">Confirm your speaker slot</span><span class=\"rf-mail-p\">Needs a yes by Friday. Hotel held near the venue.</span></div><span class=\"rf-chip rf-tone-amber\">Needs you</span></li></ul></div></div></div>"
  },
  {
   "num": "02 · CALENDAR",
   "title": "Fixes your week.",
   "sub": "They spot the conflicts, propose a fix for each and prepare the rescheduling notes.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--calendar\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Calendar</span></div><div class=\"rf-body\"><div class=\"rf-head\"><b>Week of Oct 12</b><span>13 meetings, 2 moved, no clashes</span></div><div class=\"rf-week\"><div class=\"rf-wcol\"><span class=\"rf-wday\">Mon 12</span><div class=\"rf-wev rf-tone-blue\"><span class=\"rf-wev-time\">9:30</span><b>Harlow kickoff</b><em>Brief ready</em></div><div class=\"rf-wev rf-tone-green\"><span class=\"rf-wev-time\">12:00</span><b>Lunch with Dana</b></div><div class=\"rf-wev rf-tone-blue\"><span class=\"rf-wev-time\">3:00</span><b>Site visit, Fenwick</b><em>Directions sent</em></div></div><div class=\"rf-wcol\"><span class=\"rf-wday\">Tue 13</span><div class=\"rf-wev rf-tone-graphite\"><span class=\"rf-wev-time\">10:00</span><b>Studio standup</b></div><div class=\"rf-wev rf-tone-blue\"><span class=\"rf-wev-time\">11:30</span><b>Design Week call</b><em>Slot confirmed</em></div><div class=\"rf-wev rf-tone-purple\"><span class=\"rf-wev-time\">2:00</span><b>Planning review</b></div><div class=\"rf-wev rf-tone-purple\"><span class=\"rf-wev-time\">4:30</span><b>Portfolio review</b></div></div><div class=\"rf-wcol\"><span class=\"rf-wday\">Wed 14</span><div class=\"rf-wev rf-tone-green\"><span class=\"rf-wev-time\">9:00</span><b>Focus time</b><em>Kept free</em></div><div class=\"rf-wev rf-tone-blue\"><span class=\"rf-wev-time\">1:00</span><b>Client lunch, Oakmere</b></div><div class=\"rf-wev rf-tone-purple\"><span class=\"rf-wev-time\">3:30</span><b>Interview, junior designer</b></div></div><div class=\"rf-wcol\"><span class=\"rf-wday\">Thu 15</span><div class=\"rf-wev rf-tone-blue\"><span class=\"rf-wev-time\">11:00</span><b>Harlow phase 2</b><em>Brief ready</em></div><div class=\"rf-wev rf-tone-amber\"><span class=\"rf-wev-time\">3:00</span><b>Board prep</b><em>Moved from Tue</em></div><div class=\"rf-wev rf-tone-green\"><span class=\"rf-wev-time\">6:30</span><b>Dinner, Harlow team</b><em>Table for 6</em></div></div><div class=\"rf-wcol\"><span class=\"rf-wday\">Fri 16</span><div class=\"rf-wev rf-tone-graphite\"><span class=\"rf-wev-time\">10:00</span><b>1:1 with Dana</b></div><div class=\"rf-wev rf-tone-green\"><span class=\"rf-wev-time\">12:00 on</span><b>Afternoon kept open</b><em>Your rule</em></div></div></div><div class=\"rf-sched\"><div class=\"rf-sched-wk\">Mon 12</div><ul class=\"rf-sched-list\"><li class=\"rf-sched-row rf-sched-row--time rf-tone-blue\"><span class=\"rf-sched-time\">9:30</span><span class=\"rf-sched-t\">Harlow kickoff</span><span class=\"rf-sched-c\">Brief ready</span></li><li class=\"rf-sched-row rf-sched-row--time rf-tone-green\"><span class=\"rf-sched-time\">12:00</span><span class=\"rf-sched-t\">Lunch with Dana</span><span class=\"rf-sched-c\"></span></li><li class=\"rf-sched-row rf-sched-row--time rf-tone-blue\"><span class=\"rf-sched-time\">3:00</span><span class=\"rf-sched-t\">Site visit, Fenwick</span><span class=\"rf-sched-c\">Directions sent</span></li></ul><div class=\"rf-sched-wk\">Tue 13</div><ul class=\"rf-sched-list\"><li class=\"rf-sched-row rf-sched-row--time rf-tone-graphite\"><span class=\"rf-sched-time\">10:00</span><span class=\"rf-sched-t\">Studio standup</span><span class=\"rf-sched-c\"></span></li><li class=\"rf-sched-row rf-sched-row--time rf-tone-blue\"><span class=\"rf-sched-time\">11:30</span><span class=\"rf-sched-t\">Design Week call</span><span class=\"rf-sched-c\">Slot confirmed</span></li><li class=\"rf-sched-row rf-sched-row--time rf-tone-purple\"><span class=\"rf-sched-time\">2:00</span><span class=\"rf-sched-t\">Planning review</span><span class=\"rf-sched-c\"></span></li><li class=\"rf-sched-row rf-sched-row--time rf-tone-purple\"><span class=\"rf-sched-time\">4:30</span><span class=\"rf-sched-t\">Portfolio review</span><span class=\"rf-sched-c\"></span></li></ul><p class=\"rf-sched-more\">and 8 more this week</p></div></div></div></div>"
  },
  {
   "num": "03 · MEMORY",
   "title": "Remembers your people.",
   "sub": "Past notes, preferences and who matters live in your Drive, so every briefing starts with history.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--drive\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Drive</span></div><div class=\"rf-body\"><div class=\"rf-drive\"><div class=\"rf-crumb\"><span>Drive</span><i aria-hidden=\"true\">/</i><span>Alder Row</span><i aria-hidden=\"true\">/</i><b>Admin</b></div><ul class=\"rf-files\"><li class=\"rf-file\"><span class=\"rf-ficon rf-t-pdf\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">PDF file</span></span><span class=\"rf-fname\">Travel preferences.pdf</span><span class=\"rf-fmeta\">Aisle seat, hotel near the venue</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-doc\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">Document</span></span><span class=\"rf-fname\">Board meeting notes.docx</span><span class=\"rf-fmeta\">Last 6 meetings</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-xls\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M8 13h2\"/><path d=\"M14 13h2\"/><path d=\"M8 17h2\"/><path d=\"M14 17h2\"/></svg><span class=\"rf-sr\">Spreadsheet</span></span><span class=\"rf-fname\">Key contacts.xlsx</span><span class=\"rf-fmeta\">84 people and who they are</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-dir\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z\"/></svg><span class=\"rf-sr\">Folder</span></span><span class=\"rf-fname\">Client briefs</span><span class=\"rf-fmeta\">Added by you</span></li></ul><div class=\"rf-remember\"><b>Remembered</b><p>No calls before 10, Friday afternoons stay open, and Dana is copied on every client email.</p></div></div></div></div></div>"
  },
  {
   "num": "04 · APPROVALS",
   "title": "Asks before anything is sent.",
   "sub": "Replies and invites wait for your yes. Approve, edit or skip in one tap.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--approval\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Approvals</span></div><div class=\"rf-body\"><div class=\"rf-appr\"><div class=\"rf-appr-card\"><span class=\"rf-appr-h\"><i aria-hidden=\"true\"></i>Waiting for your yes</span><p class=\"rf-appr-q\">Send this reply to Marco at Fenwick Build?</p><div class=\"rf-prev\"><div class=\"rf-prev-h\"><img src=\"https://logos.composio.dev/api/gmail\" alt=\"\" width=\"16\" height=\"16\"><span>Gmail</span><em>To: Marco Ruiz</em></div><b class=\"rf-prev-t\">Re: Site visit next week</b><p class=\"rf-prev-b\">Thanks Marco. Tuesday at 2:00 works for Sam. I have added the address and parking notes to the invite, and the drawings are attached.</p></div><div class=\"rf-appr-b\"><span class=\"rf-btn-y\">Approve</span><span class=\"rf-btn\">Edit</span><span class=\"rf-btn\">Skip</span></div></div><div class=\"rf-queue\"><span class=\"rf-queue-h\">2 more waiting</span><ul><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Reply to Dana about Friday&#x27;s client lunch</span><span class=\"rf-q-m\">Gmail · drafted</span></li><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Move the Harlow call to Thursday 3:00</span><span class=\"rf-q-m\">Calendar · 4 people</span></li></ul></div></div></div></div></div>"
  },
  {
   "num": "05 · REPORTS BACK",
   "title": "Sends a daily wrap-up.",
   "sub": "What they handled today, what is on tomorrow and the one or two things that need you.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--report\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">End of day report</span></div><div class=\"rf-body\"><div class=\"rf-report\"><div class=\"rf-rep-h\"><b>Sam&#x27;s inbox and calendar</b><span>Today, 6:05 pm</span></div><div class=\"rf-stats\"><div class=\"rf-stat\"><b>46</b><span>emails cleared</span></div><div class=\"rf-stat\"><b>3</b><span>briefings ready</span></div><div class=\"rf-stat\"><b>12</b><span>meetings this week</span></div></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--done\">Done</span><ul><li>Cleared 46 emails and drafted 5 replies</li><li>Moved 2 clashing meetings, nobody double booked</li><li>Briefing ready for the 9:30 with Harlow Group</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--next\">Next</span><ul><li>Plan the Lisbon trip: flights, hotel and a day-by-day</li><li>Follow up on 3 introductions still waiting</li><li>Confirm Thursday dinner for the Harlow team</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--need\">Needs you</span><ul><li>Approve 2 replies and the Thursday reschedule</li></ul></div></div></div></div></div>"
  }
 ],
 "capabilities": [
  {
   "title": "Triages the inbox",
   "body": "Sorts every message, drafts replies in your voice and flags what needs your attention."
  },
  {
   "title": "Untangles the calendar",
   "body": "Finds double bookings and tight travel gaps, proposes fixes and drafts the notes."
  },
  {
   "title": "Preps every meeting",
   "body": "A one-page brief before each meeting: who they are, your history, open items and questions to ask."
  },
  {
   "title": "Joins your calls",
   "body": "Sits in on Google Meet, Zoom or Microsoft Teams under their own name and files the notes and action items."
  },
  {
   "title": "Plans your travel",
   "body": "Flights, a hotel near the venue and a day-by-day itinerary, ready for you to confirm."
  },
  {
   "title": "Keeps follow-ups moving",
   "body": "Tracks who owes you what and drafts the nudge before anything goes quiet."
  }
 ],
 "steps": [
  {
   "n": "01",
   "title": "Hire in one line.",
   "body": "\"Hire an executive assistant. Start with my inbox and next week's calendar.\""
  },
  {
   "n": "02",
   "title": "Connect your inbox and calendar.",
   "body": "Add Gmail or Outlook and your calendar. You choose what they can read and send."
  },
  {
   "n": "03",
   "title": "Approve the first replies.",
   "body": "They draft the first batch and a cleaner week. You approve, edit or skip each one."
  }
 ],
 "tools": [
  {
   "name": "Gmail",
   "logo": "https://logos.composio.dev/api/gmail"
  },
  {
   "name": "Outlook",
   "logo": "https://logos.composio.dev/api/outlook"
  },
  {
   "name": "Google Calendar",
   "logo": "https://logos.composio.dev/api/googlecalendar"
  },
  {
   "name": "Zoom",
   "logo": "https://logos.composio.dev/api/zoom"
  },
  {
   "name": "Google Meet",
   "logo": "https://logos.composio.dev/api/googlemeet"
  },
  {
   "name": "Slack",
   "logo": "https://logos.composio.dev/api/slack"
  },
  {
   "name": "Notion",
   "logo": "https://logos.composio.dev/api/notion"
  },
  {
   "name": "Google Drive",
   "logo": "https://logos.composio.dev/api/googledrive"
  }
 ],
 "control": {
  "statement": "Nothing gets sent without your yes.",
  "sub": "They do the legwork.",
  "accent": "You decide what goes out in your name.",
  "rows": [
   {
    "title": "Drafts first, sends on approval",
    "body": "Every reply and invite waits for your yes by default."
   },
   {
    "title": "You set what they may send alone",
    "body": "Approve routine confirmations in advance and keep the rest on approval."
   },
   {
    "title": "Everything visible",
    "body": "Every email, meeting change and task sits on one board you can read any time."
   }
  ]
 },
 "wont": {
  "sub": "They run your inbox and calendar.",
  "accent": "Some things stay off limits.",
  "rows": [
   {
    "title": "No spending without your yes",
    "body": "They won't book, buy or pay for anything until you approve it."
   },
   {
    "title": "No commitments in your name",
    "body": "In a meeting they defer dates, prices and promises to you."
   },
   {
    "title": "No camera on calls",
    "body": "They join Google Meet, Zoom and Microsoft Teams with the camera off."
   }
  ]
 },
 "comparison": {
  "title": "Three ways to run your inbox and calendar",
  "cols": [
   "Doing it yourself",
   "A scheduling link tool",
   "AI Executive Assistant"
  ],
  "rows": [
   {
    "label": "Triages the inbox",
    "cells": [
     "You, between meetings",
     "No",
     "Yes, every morning"
    ]
   },
   {
    "label": "Resolves calendar conflicts",
    "cells": [
     "You",
     "Books open slots only",
     "Proposes fixes, you approve"
    ]
   },
   {
    "label": "Prepares meeting briefings",
    "cells": [
     "When you find time",
     "No",
     "Before every meeting"
    ]
   },
   {
    "label": "Joins your calls and takes notes",
    "cells": [
     "You",
     "No",
     "Google Meet, Zoom and Microsoft Teams"
    ]
   },
   {
    "label": "Drafts follow-up emails",
    "cells": [
     "You",
     "No",
     "Yes, for your approval"
    ]
   },
   {
    "label": "Asks before sending",
    "cells": [
     "n/a",
     "n/a",
     "Yes, by default"
    ]
   }
  ]
 },
 "prompts": [
  {
   "q": "Take these 40 minutes of meeting notes and turn them into a one-page summary with decisions, action items by owner, and a follow-up email for the team.",
   "deliverable": "a PDF summary plus a ready-to-send email draft"
  },
  {
   "q": "Here are 12 calendar invites for next week. Find the conflicts, suggest a resolution for each, and draft a rescheduling note I can send.",
   "deliverable": "a conflict report with proposed fixes and draft messages"
  },
  {
   "q": "Build a travel itinerary for my Tuesday to Thursday trip to Chicago: flights, hotel near the venue, and a day-by-day schedule with buffer time.",
   "deliverable": "a formatted itinerary PDF"
  },
  {
   "q": "Turn this stack of 18 receipts into an expense report grouped by category with totals and a summary line for accounting.",
   "deliverable": "an expense spreadsheet with categorized totals"
  },
  {
   "q": "Draft a briefing for my 2pm with the Acme team: who they are, our history with them, open items, and three questions I should ask.",
   "deliverable": "a one-page briefing"
  }
 ],
 "faq": [
  {
   "q": "What is an AI executive assistant?",
   "a": "An AI executive assistant is an AI employee that triages your inbox, drafts replies, resolves calendar conflicts, joins your video calls and prepares a briefing before each meeting."
  },
  {
   "q": "Can they send emails from my inbox?",
   "a": "Yes, once you connect Gmail or Outlook. By default every send waits for your approval. You can approve a kind of email in advance, like meeting confirmations, and your AI executive assistant sends those on their own."
  },
  {
   "q": "Can they join my meetings?",
   "a": "Yes. Add their email to the invite and they join Google Meet, Zoom or Microsoft Teams under their own name, camera off. They answer what you have authorized, never commit you to a date or a price, and file the notes and action items afterward."
  },
  {
   "q": "How do they fix calendar conflicts?",
   "a": "They read the calendar you connect, spot double bookings and back-to-back travel, propose a fix for each and draft the rescheduling notes. You approve the changes before anyone is moved."
  },
  {
   "q": "Can they book travel for me?",
   "a": "They plan the trip: flights, a hotel near the venue and a day-by-day itinerary with buffer time. Anything that spends money waits for your approval, so they prepare the booking and you confirm it."
  },
  {
   "q": "Are they an AI personal assistant or an executive assistant?",
   "a": "Both, in practice. As an AI personal assistant they run your inbox and errands; as an executive assistant they add meeting prep, briefings and follow-ups for the people you work with."
  },
  {
   "q": "Is an AI executive assistant a good fit for founders?",
   "a": "Yes. A common start is the inbox and calendar, then meeting prep and travel. They draft in your voice and keep your people and preferences in memory."
  },
  {
   "q": "How are they different from executive assistant AI tools?",
   "a": "Most executive assistant AI tools do one job, like scheduling or notes. Your AI executive assistant does the whole role: inbox, calendar, meeting briefs, calls, travel and follow-ups, and remembers your people between tasks."
  },
  {
   "q": "Can I try an AI executive assistant for free?",
   "a": "Yes. Every new account gets 200 free credits, and no credit card is needed to sign up. Use them to hire your AI executive assistant and try a first task."
  },
  {
   "q": "What does an AI executive assistant cost?",
   "a": "__COST_FAQ__"
  },
  {
   "q": "How do I get started?",
   "a": "Click \"Get started\" to sign up and hire your AI Executive Assistant in minutes, or use \"Talk to us\" and our team will help you set them up."
  }
 ],
 "ctaBand": {
  "title": "Put your AI Executive Assistant to work today",
  "body": "Hand them your last meeting's notes and get back a clean summary with action items in minutes."
 },
 "audience": {
  "title": "Who hires an AI executive assistant",
  "cards": [
   {
    "badge": "Solo founders",
    "title": "Back to the work only they can do",
    "body": "Inbox, calendar and meeting prep handed off, with a briefing waiting before every call."
   },
   {
    "badge": "Small businesses",
    "title": "An assistant for the owner",
    "body": "Owners hand off the inbox, the calendar and travel, and get a briefing before every important call."
   },
   {
    "badge": "Mid-size companies",
    "title": "Support for every leader",
    "body": "Hire one per leader. Each assistant keeps their own inbox rules and people, and the leaders you give access can see the assistant's work."
   },
   {
    "badge": "Agencies",
    "title": "Client meetings prepared",
    "body": "Account leads get a brief before each client call, and the notes and next steps filed after."
   },
   {
    "badge": "Executives and partners",
    "title": "A calendar that holds together",
    "body": "Conflicts fixed early, travel planned and every follow-up tracked to the end."
   },
   {
    "badge": "Consultants and advisors",
    "title": "Prepared for every client call",
    "body": "A brief on each client before the meeting, and the notes and action items filed after."
   }
  ]
 }
};

export default content;
